import { Author } from '../types/Author.types';

export const MOCK_AUTHORS: Author[] = [
  {
    id: 'AUT-01',
    name: 'Gabriel García Márquez',
    email: 'ggm@literatura.es',
    phone: '+57 301 555 0101',
    fiscalName: 'Gabriel José García Márquez S.L.',
    taxId: 'ESB12345678',
    address: 'Calle Mayor 45, Madrid 28013',
    bankIban: 'ES9121000418450200051332',
    bankSwift: 'CAIXESBBXXX',
    liquidationPeriod: 'semiannually',
    royaltyPercentage: 12,
    status: 'active',
    associatedBooks: ['Cien Años de Soledad'],
    notes: 'Contrato de exclusividad para la edición en tapa dura. Retención de IRPF al 15%.'
  },
  {
    id: 'AUT-02',
    name: 'Mario Vargas Llosa',
    email: 'mvll@alfaguara.com',
    phone: '+34 600 112 233',
    fiscalName: 'Mario Vargas Llosa Ediciones S.A.',
    taxId: 'ESA87654321',
    address: 'Paseo de la Castellana 12, Madrid 28046',
    bankIban: 'ES7620770024003102575766',
    bankSwift: 'SANTEESMMXXX',
    liquidationPeriod: 'quarterly',
    royaltyPercentage: 15,
    status: 'active',
    associatedBooks: ['La Ciudad y los Perros'],
    notes: 'Acuerdo para primera edición y reimpresiones. Representante legal: Agencia Carmen Balcells.'
  },
  {
    id: 'AUT-03',
    name: 'Julio Cortázar',
    email: 'jcortazar@alfaguara.es',
    fiscalName: 'Herederos de Julio Cortázar',
    taxId: 'ESB99887766',
    bankIban: 'ES1000492352082414205416',
    liquidationPeriod: 'annually',
    royaltyPercentage: 8,
    status: 'active',
    associatedBooks: ['Rayuela']
  },
  {
    id: 'AUT-04',
    name: 'Jorge Luis Borges',
    email: 'borges@emece.ar',
    fiscalName: 'Fundación Internacional Jorge Luis Borges',
    taxId: 'ESX1234567L',
    bankIban: 'ES8023100001180000012345',
    liquidationPeriod: 'annually',
    royaltyPercentage: 10,
    status: 'inactive',
    associatedBooks: ['Ficciones'],
    notes: 'Derechos gestionados a través de la Fundación. Contrato vencido pendiente de renovación.'
  }
];
